/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const rightArrowActive = {
  src: '/images/arrow-right.svg',
  alt: 'right arrow',
};
